import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const purchases = [{
  name: 'Juan P.',
  city: 'Córdoba',
  province: 'Córdoba'
}, {
  name: 'María S.',
  city: 'Rosario',
  province: 'Santa Fe'
}, {
  name: 'Lucas M.',
  city: 'Mendoza',
  province: 'Mendoza'
}, {
  name: 'Sofía G.',
  city: 'La Plata',
  province: 'Buenos Aires'
}, {
  name: 'Diego R.',
  city: 'Salta',
  province: 'Salta'
}, {
  name: 'Valentina B.',
  city: 'Neuquén',
  province: 'Neuquén'
}, {
  name: 'Mateo L.',
  city: 'San Miguel',
  province: 'Tucumán'
}, {
  name: 'Camila F.',
  city: 'Mar del Plata',
  province: 'Buenos Aires'
}, {
  name: 'Nicolás T.',
  city: 'Posadas',
  province: 'Misiones'
}, {
  name: 'Agustina V.',
  city: 'Resistencia',
  province: 'Chaco'
}, {
  name: 'Facundo D.',
  city: 'Bahía Blanca',
  province: 'Buenos Aires'
}, {
  name: 'Martina K.',
  city: 'Santa Fe',
  province: 'Santa Fe'
}, {
  name: 'Joaquín H.',
  city: 'San Juan',
  province: 'San Juan'
}, {
  name: 'Lucía M.',
  city: 'Corrientes',
  province: 'Corrientes'
}, {
  name: 'Santiago N.',
  city: 'San Salvador',
  province: 'Jujuy'
}, {
  name: 'Elena W.',
  city: 'Bariloche',
  province: 'Río Negro'
}, {
  name: 'Tomás C.',
  city: 'Paraná',
  province: 'Entre Ríos'
}, {
  name: 'Rocío J.',
  city: 'Formosa',
  province: 'Formosa'
}, {
  name: 'Bautista E.',
  city: 'Catamarca',
  province: 'Catamarca'
}, {
  name: 'Milagros Q.',
  city: 'La Rioja',
  province: 'La Rioja'
}];
export function SocialProofPopup() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before first popup
    const showTimer = setTimeout(() => setIsVisible(true), 2000);
    // Cycle every 7 seconds
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setIndex(prev => (prev + 1) % purchases.length);
        setIsVisible(true);
      }, 1000); // 1s for exit animation before next one
    }, 7000);
    return () => {
      clearTimeout(showTimer);
      clearInterval(cycleInterval);
    };
  }, []);
  const current = purchases[index];
  return <div className="fixed bottom-4 left-4 z-[100] pointer-events-none" data-id="element-265">
      <AnimatePresence data-id="element-266">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className="bg-brand-navy border border-white/10 p-4 rounded-xl shadow-2xl flex items-center gap-4 max-w-[280px] pointer-events-auto" data-id="element-267">
            <div className="w-10 h-10 bg-brand-green/20 rounded-full flex items-center justify-center shrink-0" data-id="element-268">
              <StarIcon size={20} className="text-brand-gold fill-brand-gold" data-id="element-269" />
            </div>
            <div data-id="element-270">
              <div className="text-sm font-bold text-white" data-id="element-271">
                {current.name} acaba de comprar
              </div>
              <div className="text-xs text-gray-400" data-id="element-272">
                {current.city}, {current.province}
              </div>
              <div className="flex items-center gap-1 mt-1" data-id="element-273">
                <StarIcon size={10} className="text-brand-gold fill-brand-gold" data-id="element-274" />
                <span className="text-[10px] font-bold text-brand-green uppercase tracking-wider" data-id="element-275">
                  Compra verificada
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}